import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { endpoints } from './api';
import { useSession } from './session';

/** The seller's overview. */
export function useDashboard() {
    return useQuery({
        queryKey: ['dashboard'],
        queryFn: endpoints.dashboard,
        // Refreshed while the tab is open, because the interesting numbers are the
        // ones that change while nobody is looking: an order arriving, a channel
        // starting to fail.
        refetchInterval: 60_000,
    });
}

/**
 * The write each setup step asks of its own module. The API turns away a role
 * holding none of them, so the card is asked for only by a session that holds
 * one; which steps it is answered is the API's call, never this list's.
 */
const SETUP_PERMISSIONS = ['channel.write', 'product.write', 'category.write', 'invoice.write', 'storefront.write'];

/** The first steps that make the account work, as far as this person may do them. */
export function useSetup() {
    const { can } = useSession();
    return useQuery({
        queryKey: ['setup'],
        queryFn: endpoints.setup,
        enabled: SETUP_PERMISSIONS.some(can),
        // A step turns done on the page that completes it, and the card is read
        // again the next time Genel Bakış opens rather than up to ten seconds
        // after.
        staleTime: 0,
    });
}

/**
 * Closes the setup card for this person. It needs only a session: the mark is
 * on the person's own membership, so it is not a write the role decides.
 */
export function useDismissSetup() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: () => endpoints.dismissSetup(),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['setup'] }),
    });
}
